<template>
  <div class="smy__card-full-box">
      <div class="timeLine" style="padding:20px 20px;line-height:20px;">
        <Timeline>
         <TimelineItem
          v-for="timeList in followDetail"
          :key="timeList.id"
          :value="timeList.id"
         >
         <span style="float:right;">{{timeList.createtime}}</span>
             <p class="time">
               {{timeList.create_user_name}}{{'【'+timeList.role_name+'】'}}
             </p>
             <p class="content">
                {{timeList.type ? '跟进节点：' + followUpType.filter(item => item.value === timeList.type)[0].name : ''}}
                <br v-if="timeList.type">
                {{timeList.content}}
             </p>
             <template v-if="timeList.img_urls">
               <div class="demo-upload-list" v-for="item in timeList.img_urls.split(',')">
                <template>
                  <img :src="item" style="width: 80px;height: 80px;">
                </template>
               </div>
             </template>
         </TimelineItem>
       </Timeline>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { followUpType } from '@/assets/globalData'

export default {
  props: {
    followDetail: {
      type: Array
    }
  },
  data () {
    return {
      dataOne: 0,
//    followDetail: [],
      imgItems: [],
      pageIndex: 0,
      pageSize: 10,
      count: '',
      epId: '',
      followUpType
    }
  },
  computed: {
    ...mapState('followCustom', [
      'id'
    ])
  },
  methods: {
  },
  created () {
//  //  跟进记录
//  this.$http.get('/enterprise/followup/list', {
//    params: {
//      pageIndex: this.pageIndex,
//      pageSize: this.pageSize,
//      epId: this.id
//    }
//  }).then(res => {
//    this.followDetail = res.data
//  })
//  //  跟进记录数量
//  this.$http.get('/enterprise/followup/count', {
//    params: {
//      epId: this.id
//    }
//  }).then(res => {
//    this.count = res.data
//  })
  }
}
</script>

<style lang="less" scoped>
 .smy__card-full-box{
   .demo-upload-list{
     display: table-cell;
    img{
      margin-right: 10px;
    }
   }
 }
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetailRightOne.vue